<mat-card appearance="outlined" class="sign-off-employee-card hdmui-p-4">
    <div class="sign-off-employee-card__headers">
        <h1 class="hdmui-font-serif hdmui-m-0 sign-off-employee-card__info-text">
            {{ machine.machineName }}
        </h1>
        <h1 class="hdmui-font-bold hdmui-m-0" data-testid="sign-off-operation-card-machineId">
            {{ machine.machineId }}
        </h1>
    </div>
    <p class="sign-off-employee-card__info hdmui-m-0 hdmui-mt-3">
        {{ 'DC.SIGN_OFF_DIALOG.OPERATIONS.CARD.DESCRIPTION' | translate: { opName: translatedOpName } }}
    </p>
    <form [formGroup]="formGroup">
        <div class="report-form">
            <div class="sign-off-employee-card__buttons">
                <mat-radio-group
                    [value]="PAUSE"
                    [name]="'operation' + machine.machineId"
                    formControlName="operationAction"
                >
                    <mat-radio-button
                        [name]="'operation' + machine.machineId"
                        [value]="PAUSE"
                        data-testid="sign-off-operation-card-radio-button-pause"
                    >
                        {{ 'DC.SIGN_OFF_DIALOG.OPERATIONS.CARD.PAUSE' | translate }}
                    </mat-radio-button>
                    <mat-radio-button
                        [name]="'operation' + machine.machineId"
                        [value]="FINISH"
                        data-testid="sign-off-operation-card-radio-button-finish"
                    >
                        {{ 'DC.SIGN_OFF_DIALOG.OPERATIONS.CARD.FINISH' | translate }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div>
                <p class="hdmui-font-bold hdmui-m-0 hdmui-mt-3 hdmui-p-0 sign-off-employee-card__label-amounts">
                    {{ 'DC.OPERATIONS.OPERATION_DETAILS.AMOUNTS' | translate }}
                </p>
                <mat-form-field>
                    <mat-label> {{ 'DC.REPORT_LAST_AMOUNTS.GOOD' | translate }}</mat-label>
                    <input
                        matInput
                        formControlName="goodCount"
                        (blur)="onInputOut()"
                        mask="separator.0"
                        data-testid="sign-off-operation-card-added-good"
                    />
                </mat-form-field>
                <mat-form-field>
                    <mat-label> {{ 'DC.REPORT_LAST_AMOUNTS.WASTE' | translate }}</mat-label>
                    <input
                        matInput
                        formControlName="wasteCount"
                        (blur)="onInputOut()"
                        mask="separator.0"
                        data-testid="sign-off-operation-card-added-waste"
                    />
                </mat-form-field>
                <p class="hdmui-caption hdmui-m-0 hdmui-my-3 hdmui-p-0 sign-off-employee-card__amounts-info">
                    {{ 'DC.REPORT_LAST_AMOUNTS.GOOD_WASTE_INFO' | translate }}
                </p>
                <mat-form-field>
                    <mat-label> {{ 'DC.SIGN_OFF_DIALOG.OPERATIONS.CARD.COMMENT' | translate }}</mat-label>
                    <textarea
                        matInput
                        rows="3"
                        formControlName="comment"
                        data-testid="sign-off-operation-card-comment"
                    ></textarea>
                </mat-form-field>
            </div>
            <data-terminal-amount-report-details
                [formData]="formData$ | async"
                [operationData]="operationData$ | async"
                [isFinishOperation]="formGroup.controls.operationAction.value === FINISH"
                [isAmountsReportingAllowed]="true"
            ></data-terminal-amount-report-details>
        </div>
    </form>
</mat-card>
